export const SHOW_USER_INFORMATION = "SHOW_USER_INFORMATION";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";